import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import './style.scss';
import documentUINamesConstant from '../../../../../apis/documentUINamesConstant';
import DocumentSequenceV2 from '..';

const AllEntityList = ({
  user,
}) => {
  const [currentDocTab, setCurrentDocTab] = useState('PURCHASE_ORDER');

  const getItem = (label, key, icon, children, type) => ({
    label,
    key,
    icon,
    children,
    type,
  });

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  const items = [
    getItem('Stock Adjustment', 'INVENTORY_ADJUSTMENT'),
    getItem('Stock Transfer', 'STOCK_TRANSFER'),
    getItem('Delivery Challan', 'DELIVERY_CHALLAN'),
    getItem('Gate Document', 'GATE_DOCUMENT'),
    getItem('Material Request', 'MATERIAL_REQUEST'),
    getItem('Purchase Indent', 'PURCHASE_INDENT'),
    getItem('Request For Quotation', 'REQUEST_FOR_QUOTATION'),
    getItem('Purchase Order', 'PURCHASE_ORDER'),
    getItem('Goods Receiving Note', 'GOOD_RECEIVING_NOTE'),
    getItem('Account Payable Invoice', 'ACCOUNT_PAYABLE_INVOICE'),
    getItem('Debit Note', 'DEBIT_NOTE'),
    getItem('Expense', 'EXPENSE'),
    // getItem('Bill of Material', 'BILL_OF_MATERIAL'),
    getItem('Manufacturing Order', 'MANUFACTURING_ORDER'),
    getItem('Manual Production Entry', 'MANUAL_PRODUCTION_ENTRY'),
    getItem('Job Work', 'JOB_WORK'),
    getItem('MRP', 'MATERIAL_REQUIREMENT_PLANNING'),
    getItem('Quality Rules', 'QUALITY_CONTROL_RULE'),
    getItem(documentUINames.estimateUIName, 'SALES_ESTIMATE'),
    getItem(documentUINames.salesOrderUIName, 'SALES_ORDER'),
    getItem('Annual Maintenance Contract', 'ANNUAL_MAINTENANCE_CONTRACT'),
    getItem('Packing Slip', 'PACKING_SLIP'),
    getItem('Invoice', 'INVOICE'),
    getItem('Consumption Order', 'CONSUMPTION_ORDER'),
    getItem('Credit Note', 'CREDIT_NOTE'),
    getItem('Return Slip', 'RETURN_SLIP'),

  ];

  return (
    <div className="document-seq__wrapper-outer">
      <div className="document-seq__menu">
        <Menu
          onClick={(event) => {
            setCurrentDocTab(event.key);
          }}
          style={{
            width: 226,
            overflowY: 'auto',
            maxHeight: 'calc(100dvh - 140px)',
            overflowX: 'hidden',
          }}
          selectedKeys={[currentDocTab]}
          defaultSelectedKeys={['1']}
          mode="inline"
          items={items}
        />
      </div>
      <div className="document-seq-menu-items">
        {
          items?.map((item) => {
            if (item.key === currentDocTab) {
              return (
                <DocumentSequenceV2
                  key={item.key}
                  label={item.label}
                  entityName={item.key}
                />
              );
            }
            return null;
          })
        }
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AllEntityList));
